@if (model$ | async; as model) {
    <div class="reward-tokens-container__header">
        <div class="reward-tokens-container__header-title">
            {{ getTitle(model) }}
            @if (!isEpcotEnabled) {
                <button
                    class="reward-tokens-container__header-info"
                    ds-button-icon
                    kind="utility"
                    variant="flat-reduced"
                    size="medium"
                    (click)="displayInfo($event)">
                    <vn-icon name="theme-info"></vn-icon>
                </button>
            }
        </div>
        <div class="reward-tokens-container__header-right">
            @if (!isRewardDrawerEnabled) {
                @if (showClearButton(model)) {
                    <div class="reward-tokens-container__remove-button" (click)="clearToken(model)">
                        {{ sitecore.crmTokens.messages.RemoveTokenButton }}
                    </div>

                    <div class="reward_separator"></div>
                }
            }

            @if (isEpcotEnabled) {
                <div class="reward-tokens-container__header-close" (click)="closeDialog()">
                    {{ sitecore.globalMessages.Close }}
                </div>
            } @else {
                <button
                    class="reward-tokens-container__header-close"
                    ds-button-icon
                    kind="utility"
                    variant="flat-reduced"
                    size="medium"
                    (click)="closeDialog()">
                    <vn-icon name="theme-ex"></vn-icon>
                </button>
            }
        </div>
    </div>

    <ng-scrollbar class="reward-tokens-container__list-scroller ng-scrollbar-compact" [bsRewardTokensDrawerScroll]="shouldScrollToContent">
        <div class="reward-tokens-container__list">
            @if (model.accaBoostToken) {
                <bs-reward-tokens-card
                    [tokenInfo]="model.accaBoostToken"
                    [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                    (cardClick)="selectToken($event)"></bs-reward-tokens-card>
            }
            @if (model.accaBoostToken && model.crmTokens.length) {
                <div class="reward-tokens-container__section-title">
                    {{ sitecore.crmTokens.messages.TokensSectionTitle }}
                </div>
            }
            @for (token of model.crmTokens; track token) {
                <bs-reward-tokens-card
                    [tokenInfo]="token"
                    [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                    [tokenContext]="tokenContext"
                    (cardClick)="selectToken($event)"></bs-reward-tokens-card>
            }
        </div>
    </ng-scrollbar>

    @if (isDoneCTAEnabled) {
        <div class="reward-tokens-container__done">
            <button
                class="reward-tokens__done-cta"
                ds-button
                kind="primary"
                variant="filled"
                size="large"
                [disabled]="isDoneButtonDisabled"
                (click)="doneButtonClick()">
                {{ sitecore.crmTokens.messages.Done }}
            </button>
        </div>
    }
}
